import { useState } from 'react';
import TypingText from '../UtilityComponents/TypingText';
import { apiCodeSuggestions } from '../../api';

const getFeedbackMessage = (totalScore) => {
  if (totalScore === 1 || totalScore >= 0.9) {
    return `Τέλεια απάντηση με συντελεστή επιτυχίας ${Math.round(totalScore * 100)}%. Συγχαρητήρια!`;
  } else if (totalScore < 0.9 && totalScore >= 0.65) {
    return `Πολύ καλή απάντηση με συντελεστή επιτυχίας ${Math.round(totalScore * 100)}%. Προσπάθησε λίγο ακόμη!`;
  } else if (totalScore < 0.65 && totalScore >= 0.45) {
    return `Μέτρια προς καλή απάντηση με συντελεστή επιτυχίας ${Math.round(totalScore * 100)}%. Προσπάθησε κι άλλο!`;
  } else if (totalScore < 0.45 && totalScore >= 0.25) {
    return `Μέτρια προς κακή απάντηση με συντελεστή επιτυχίας ${Math.round(totalScore * 100)}%. Παρακαλώ χρειάζεσαι περισσότερη δουλειά!`;
  } else if (totalScore < 0.25) {
    return `Κακή απάντηση με συντελεστή επιτυχίας ${Math.round(totalScore * 100)}%. Μελέτησε παραπάνω γιατί θα αποτύχεις!!`;
  }
};

const Answer = ({ totalScore, userAnswer, answer, answerCode, userCode }) => {
  const feedbackMessage = getFeedbackMessage(totalScore);
  const [suggestions, setSuggestions] = useState('');
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [hasFetchedSuggestions, setHasFetchedSuggestions] = useState(false);

  const hasCode = userCode && userCode !== 'null' && userCode !== '' && 
                  answerCode && answerCode !== null && answerCode !== '';

  const toggleSuggestions = async () => {
    if (!hasCode) return;
    
    // If already showing, just hide (don't refetch)
    if (showSuggestions) {
      setShowSuggestions(false);
      return;
    }
    
    // Show the section
    setShowSuggestions(true);
    
    // Only fetch if we haven't fetched before
    if (!hasFetchedSuggestions) {
      setLoadingSuggestions(true);
      
      try {
        const data = await apiCodeSuggestions(userCode, answerCode);
        setSuggestions(data.suggestions || 'Δεν ήταν δυνατή η λήψη προτάσεων.');
        setHasFetchedSuggestions(true);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setSuggestions('Σφάλμα κατά τη λήψη προτάσεων.');
      } finally {
        setLoadingSuggestions(false);
      }
    }
  };

  return (
    <>
      <p>{feedbackMessage}</p>
      <div style={{ textAlign: 'center' }}>
        <button className="reveal-button" onClick={toggleAnswer1}>Η απάντησή σου</button>
      </div>
      <div id="userAnswer" style={{ display: 'none', backgroundColor: 'black' }}>
        <p2 style={{ textAlign: 'center' }}>{userAnswer!=="null"?(userAnswer):("")}<br /><xmp>{userCode!=="null"&&userCode!==""?(userCode):("")}</xmp></p2><br />
      </div>
      <br />
      <br />
      <div style={{ textAlign: 'center' }}>
        <button className="reveal-button" onClick={toggleAnswer}>Η σωστή απάντηση!</button>
      </div>
      <div id="correctAnswer" style={{ display: 'none', backgroundColor: 'black' }}>
        <p2>{answer!==null?(answer):("")}<br /><xmp>{answerCode !==null?(answerCode):("")}</xmp></p2><br />
      </div>
      
      {hasCode && (
        <>
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <button className="reveal-button" onClick={toggleSuggestions} disabled={loadingSuggestions}>
              {loadingSuggestions ? 'Φόρτωση...' : showSuggestions ? 'Απόκρυψη προτάσεων AI' : 'Προτάσεις AI για βελτίωση'}
            </button>
          </div>
          {showSuggestions && (
            <div id="aiSuggestions" style={{ 
              display: 'block', 
              backgroundColor: 'black',
              padding: '20px',
              margin: '15px 0'
            }}>
              {loadingSuggestions ? (
                <p style={{ textAlign: 'center' }}>
                  <TypingText text="Το AI αναλύει τον κώδικά σου..." />
                </p>
              ) : (
                <p2 style={{ display: 'block', lineHeight: '1.6' }}>
                  <TypingText text={suggestions} />
                </p2>
              )}
              <br />
            </div>
          )}
        </>
      )}
    </>
  );
};

function toggleAnswer1() {
  var y = document.getElementById("userAnswer");
  if (y.style.display === "none") {
    y.style.display = "block";
  } else {
    y.style.display = "none";
  }
}

function toggleAnswer() {
  var x = document.getElementById("correctAnswer");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

export default Answer
